import React from 'react';
import { runStrategies, extractPluginsConfig, fetchEmbedData, themeStrategy, experimentStrategy, } from '@wix/ricos-common';
import { merge } from 'lodash';
import { runViewerStrategies } from './runViewerStrategies';
import { RICOS_VERSION } from 'ricos-schema/next';
export const createWixRicosViewer = (RicosViewer) => function WixRicosViewer(props) {
    const { children, biSettings, instance, plugins, theme, wixExperiments, allowLinkPreviewPopover, httpClient, msid, baseUrl, previewMode, content, ...rest } = props;
    const experiments = experimentStrategy(wixExperiments);
    const strategyProps = runStrategies({
        plugins,
        instance,
        biSettings,
        experiments,
        wixRicosVersion: RICOS_VERSION,
        ricosVersion: RICOS_VERSION,
        httpClient,
        msid,
        viewer: true,
        content,
    });
    const _rcProps = merge(strategyProps, runViewerStrategies(plugins, baseUrl, previewMode), extractPluginsConfig(plugins, strategyProps.helpers));
    return (React.createElement(RicosViewer, { _rcProps: _rcProps, content: content, experiments: strategyProps.experiments, plugins: plugins, theme: themeStrategy(theme), ...(allowLinkPreviewPopover && {
            linkPreviewPopoverFetchData: fetchEmbedData(instance),
        }), ...rest }, children));
};
//# sourceMappingURL=WixRicosViewerNext.js.map